var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "johcc8eapa",
    cx: 20,
    cy: 20,
    r: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "diqd6zswpb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#johcc8eapa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D2D7DB",
    xlinkHref: "#johcc8eapa"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#diqd6zswpb)",
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 13.5a1 1 0 0 1-1-1V11h-4v1.5a1 1 0 0 1-2 0V11c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2v1.5a1 1 0 0 1-1 1zM20.71 22.38a2.191 2.191 0 0 1-1.48-.02L8 18.62v7.63C8 27.77 9.23 29 10.75 29h18.5c1.52 0 2.75-1.23 2.75-2.75v-7.63l-11.29 3.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 14.75v2.29l-11.76 3.92c-.08.03-.16.04-.24.04-.08 0-.16-.01-.24-.04L8 17.04v-2.29C8 13.23 9.23 12 10.75 12h18.5c1.52 0 2.75 1.23 2.75 2.75z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.63caee27c0d8d2222e86562d18ec2b0f.svg";
export { ForwardRef as ReactComponent };